import React from 'react'
import { useOutletContext } from 'react-router-dom'

import { SecuritySettingsOutletCtx } from '../SecuritySettings.page'
import { ChangePasswordForm } from './ChangePasswordForm'

export const PasswordChangePage: React.FC = () => {
  const { onSubmitChangePassword } = useOutletContext<SecuritySettingsOutletCtx>()

  return <ChangePasswordForm onSubmit={onSubmitChangePassword} />
}
